import React from 'react'
import ReactDOM from 'react-dom'

export function AlertModal({ show, type = 'info', title, message, onClose }) {
  if (!show) return null

  const config = {
    success: { bg: 'from-green-500 to-green-600', icon: '✅', btnColor: 'bg-green-600 hover:bg-green-700' },
    error:   { bg: 'from-red-500 to-red-600',     icon: '❌', btnColor: 'bg-red-600 hover:bg-red-700' },
    warning: { bg: 'from-yellow-400 to-orange-500', icon: '⚠️', btnColor: 'bg-orange-500 hover:bg-orange-600' },
    info:    { bg: 'from-blue-500 to-blue-600',    icon: 'ℹ️', btnColor: 'bg-blue-600 hover:bg-blue-700' },
    lock:    { bg: 'from-red-600 to-red-700',      icon: '🔒', btnColor: 'bg-red-600 hover:bg-red-700' }
  }

  const c = config[type] || config.info

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className={`bg-gradient-to-br ${c.bg} p-8 text-center`}>
          <div className="text-5xl mb-4">{c.icon}</div>
          <h3 className="text-xl font-bold text-white">{title}</h3>
        </div>
        <div className="p-6">
          {message && <p className="text-sm text-gray-600 text-center leading-relaxed mb-6">{message}</p>}
          <button onClick={onClose}
            className={`w-full py-3 ${c.btnColor} text-white rounded-2xl text-sm font-semibold transition-all shadow-lg`}>
            ตกลง
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export function ConfirmModal({ show, type = 'warning', title, message, onConfirm, onCancel, confirmText = 'ยืนยัน', cancelText = 'ยกเลิก' }) {
  if (!show) return null

  const config = {
    warning: { bg: 'from-yellow-400 to-orange-500', icon: '⚠️', confirmBtn: 'bg-orange-500 hover:bg-orange-600' },
    danger:  { bg: 'from-red-500 to-red-600',       icon: '🗑️', confirmBtn: 'bg-red-600 hover:bg-red-700' },
    info:    { bg: 'from-blue-500 to-blue-600',      icon: 'ℹ️', confirmBtn: 'bg-blue-600 hover:bg-blue-700' },
    success: { bg: 'from-green-500 to-green-600',    icon: '✅', confirmBtn: 'bg-green-600 hover:bg-green-700' }
  }

  const c = config[type] || config.warning

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className={`bg-gradient-to-br ${c.bg} p-8 text-center`}>
          <div className="text-5xl mb-4">{c.icon}</div>
          <h3 className="text-xl font-bold text-white">{title}</h3>
        </div>
        <div className="p-6">
          {message && <p className="text-sm text-gray-600 text-center leading-relaxed mb-6">{message}</p>}
          <div className="flex gap-3">
            <button onClick={onCancel}
              className="flex-1 py-3 border-2 border-gray-200 text-gray-600 rounded-2xl text-sm font-semibold hover:bg-gray-50 transition-all">
              {cancelText}
            </button>
            <button onClick={onConfirm}
              className={`flex-1 py-3 ${c.confirmBtn} text-white rounded-2xl text-sm font-semibold shadow-lg transition-all`}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export function useModal() {
  const [alert, setAlert] = React.useState({ show: false, type: 'info', title: '', message: '' })
  const [confirm, setConfirm] = React.useState({ show: false, type: 'warning', title: '', message: '', onConfirm: null })

  const showAlert = (type, title, message) => {
    setAlert({ show: true, type, title, message })
  }

  const showConfirm = (type, title, message) => {
    return new Promise((resolve) => {
      setConfirm({
        show: true, type, title, message,
        onConfirm: () => { setConfirm(c => ({ ...c, show: false })); resolve(true) },
        onCancel:  () => { setConfirm(c => ({ ...c, show: false })); resolve(false) }
      })
    })
  }

  const closeAlert = () => setAlert(a => ({ ...a, show: false }))

  const ModalComponents = () => (
    <>
      <AlertModal show={alert.show} type={alert.type} title={alert.title} message={alert.message} onClose={closeAlert} />
      <ConfirmModal show={confirm.show} type={confirm.type} title={confirm.title} message={confirm.message} onConfirm={confirm.onConfirm} onCancel={confirm.onCancel} />
    </>
  )

  return { showAlert, showConfirm, ModalComponents }
}